'use client';

import { AccordionProviderPersisted } from '@/uiComposites/interactive/accordion/AccordionProvider.client';
import { ReactNode, useSyncExternalStore } from 'react';
import { getStepID } from './StepByStepItem.client';

export const StepByStepAccordionProvider = ({
	steps,
	children,
}: {
	steps: Array<{ title: string }>;
	children: ReactNode;
}) => {
	const defaultOpenedIndex = useSyncExternalStore(
		() => {
			return () => {};
		},
		() => {
			if (window.location.hash === '') return undefined;

			const index = steps.findIndex((step) => {
				return `#${getStepID(step.title)}` === window.location.hash;
			});

			if (index === -1) return undefined;
			// This needs to be a primitive value
			// because otherwise react will rerender
			// infinite times.
			return index;
		},
		() => undefined,
	);

	return (
		<AccordionProviderPersisted
			accordionKey={'stepByStep'}
			defaultOpened={
				defaultOpenedIndex != null ? new Set([defaultOpenedIndex]) : undefined
			}
		>
			{children}
		</AccordionProviderPersisted>
	);
};
